module.exports = __webpack_public_path__ + "static/img/2-Kensa-ground-source-heat-pump-technology.d6799902.jpg";